import   Style  		    from "components/UI/main.module.scss";
import { useState } 		from 'react';
import { BtnCloseAction }	from "components/Buttons/Close/BtnClose";

// This will manage the modal state globally
let showModalCallback 	= null;
let hideModalCallback 	= null;

export const useModal = () => {
  const showModal = (...args) => {
    if (typeof showModalCallback === "function") {
      showModalCallback(...args);
    }
  };

  const hideModal = () => {
    if (typeof hideModalCallback === "function") {
      hideModalCallback();
    }
  };

  return { showModal, hideModal };
};

export const Modal = () => {
  	const [displayModal, setDisplayModal] = useState(false);
  	const [body, setBody] = useState(null);
  	const [confirmAction, setConfirmAction] = useState(() => () => {}); // Store confirm callback

	showModalCallback = (children, confirm_action) => {
		setBody(children);
		if (confirm_action) {
			setConfirmAction(() => () => {
			confirm_action();
			setDisplayModal(false);
			});
		} else {
			setConfirmAction(null);
		}

		setDisplayModal(true);
	};

	hideModalCallback = () => setDisplayModal(false);


	const closePopUp = () => setDisplayModal(false);

	return (
		<>
			{displayModal && (
				<div className={[Style.modal_child].join(" ")}>
					<div className={[Style.modal_dialog].join(" ")}>
						<div className={[   Style.modal_content, 
                                            Style.rounded_3, 
                                            Style.shadow_sm, 
                                            Style.border, 
                                            Style.mx_2].join(" ")}
                        >
							<div className={[   Style.modal_header_bg, 
                                                Style.rounded_top_3].join(" ")}
                            >
								<div className={Style.row}>
									<div className={Style.col}>
										<div className={[Style.text_end, Style.m_1].join(" ")}>
											{<BtnCloseAction click_action={closePopUp}/>}
										</div>
									</div>
								</div>
							</div>
							<div className={[   Style.modal_bg, Style.rounded_bottom_3].join(" ")}>
                                {body}
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

